<template>
  <crud-form
    v-model="payload"
    :request-class="requestClass"
    :page-title="pageTitle"
    :total-group="1"
    :navigate-back-route="backRoute"
    :navigate-page-after-save="backRoute"
    :extra-validated="extraValidated"
    :override-create-payload="overrideCreatePayload"
    :disabled-update="isEdit"
  >
    <template slot="group-1">
      <form-group>
        <v-row>
          <v-col cols="12">
            <input-radio
              id="input:isAcceptanceMandatory"
              v-model="payload.isAcceptanceMandatory"
              :options="radioOptions"
              :rules="[requiredRule]"
              :disabled="isEdit"
              label="Aceite obrigatório:"
              row
            />
          </v-col>
        </v-row>
        <v-row v-if="isEdit">
          <v-col cols="6">
            <input-date
              id="input:createdAt"
              v-model="payload.createdAt"
              label="Data de criação"
              :disabled="isEdit"
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:createdByName"
              v-model="payload.createdByName"
              label="Criado por"
              :disabled="isEdit"
            />
          </v-col>
        </v-row>
        <v-row
          justify="end"
          align="end"
        >
          <v-col cols="3">
            <preview-modal
              v-model="payload.document"
              :title="pageTitle"
            />
          </v-col>
        </v-row>
        <v-row class="py-6">
          <v-col cols="12">
            <editor-code
              id="input:document"
              :code="payload.document"
              :readonly="isEdit"
              @update-code="code => payload.document = code"
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import LegalAgreementsRequest from 'Modules/contacard/legalAgreements/LegalAgreementsRequest';
import PreviewModal from '@/app/arch/components/modals/PreviewModal.vue';

export default {
  name: 'LegalAgreementsForm',
  components: { CrudForm, FormGroup, PreviewModal },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: LegalAgreementsRequest,
    agreementType: '',
    payload: {
      type: '',
      document: '',
      isAcceptanceMandatory: '',
      createdAt: '',
      createdByName: '',
    },
    radioOptions: [
      {
        label: 'Sim',
        value: true,
      },
      {
        label: 'Não',
        value: false,
        color: 'primary',
      },
    ],
  }),
  computed: {
    backRoute() {
      return this.returnLegalAgreements(
        'termsOfUse.list',
        'privacyPolicy.list',
        'legalContract.list',
      );
    },
    extraValidated() {
      return () => !!this.payload.document || !!this.payload.isAcceptanceMandatory;
    },
    getId() {
      return this.$route.params.id;
    },
    isEdit() {
      return this.getId && Number(this.getId) >= 0;
    },
    SetTitleType() {
      return this.returnLegalAgreements(
        'termos de uso',
        'políticas de privacidade',
        'contrato',
      );
    },
    returnLegalAgreements() {
      return (termsReturn, policyReturn, contractReturn) => {
        if (this.isTerms) {
          return termsReturn;
        }
        if (this.isPolicy) {
          return policyReturn;
        }
        if (this.isContract) {
          return contractReturn;
        }
        return '';
      };
    },
    getType() {
      return this.agreementType;
    },
    isTerms() {
      return this.getType === 'TermsOfUse';
    },
    isPolicy() {
      return this.getType === 'PrivacyPolicy';
    },
    isContract() {
      return this.getType === 'NewSgvOnboardingContract';
    },
    pageTitle() {
      return this.isEdit
        ? `Visualizar ${this.SetTitleType}`
        : `Criar ${this.SetTitleType}`;
    },
  },
  methods: {
    overrideCreatePayload(payload) {
      return {
        ...payload,
        type: this.agreementType,
      };
    },
  },
};
</script>
